// extracted by mini-css-extract-plugin
module.exports = {"section":"ListAni_section__dTQa4"};